import { useLanguage } from '../../i18n/LanguageContext';

function StatsSection() {
    const { t } = useLanguage();
    const stats = [
        { count: 248000, suffix: '+', label: t.statPackets },
        { count: 190, suffix: '+', label: t.statCountries },
        { count: 1200, suffix: '+', label: t.statBrands },
        { count: 6, suffix: '', label: t.statNetworks },
    ];

    return (
        <section className="home-stats">
            <div className="wrap">
                <div className="stats">
                    {stats.map((s, index) => (
                        <div className="stat rv" key={s.label} style={{ '--rv-delay': `${index * 80}ms` }}>
                            <div className="num" data-count={s.count} data-suffix={s.suffix}>
                                0
                            </div>
                            <span>{s.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default StatsSection;
